const { produce } = require("immer");

const init = {
  uid: null,
  name: null,
  expiration: null,
  profileUid: null,
  roleUid: null
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_invitationForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
        if(action.form.profile) draft.profileUid = action.form.profile;
        if(action.form.role) draft.roleUid = action.form.role;
      });

    case "UPDATE_invitationForm":
      return produce(state, draft => {
        Object.assign(draft, action.form);
      });

    case "RESET_invitationForm":
      return init;

    default:
      return state;
  }
}
